/**
 * Papéis do backend (referência). Manter ROLE_CONFIG alinhado a estes nomes.
 * Customer: PHYSICAL_*, LEGAL_PERSON, EXTERNAL_*, COST_CENTER_*, EXTERNAL_DELIVERY_CREATOR
 * Transporte: EMPLOYEE, HR_EMPLOYEE, TRANSPORT_COMPANY, DRIVER, DELIVERY_CREATOR
 */
export const BACKEND_ROLE_KEYS = [
    'ROLE_PHYSICAL_PERSON',
    'ROLE_PHYSICAL_COSTUMER',
    'ROLE_LEGAL_PERSON',
    'ROLE_EXTERNAL_EMPLOYEE',
    'ROLE_HR_EXTERNAL_EMPLOYEE',
    'ROLE_COST_CENTER_MANAGER',
    'ROLE_COST_CENTER_EMPLOYEE',
    'ROLE_EXTERNAL_DELIVERY_CREATOR',
    'ROLE_EMPLOYEE',
    'ROLE_HR_EMPLOYEE',
    'ROLE_TRANSPORT_COMPANY',
    'ROLE_DRIVER',
    'ROLE_DELIVERY_CREATOR',
];

/**
 * Labels/cores da UI + entradas legadas (ROLE_COMPANY, ROLE_COST_CENTER) se a API ainda enviar.
 */
export const ROLE_CONFIG = {
    ROLE_PHYSICAL_PERSON: { color: '#667eea', label: 'Pessoa física' },
    ROLE_PHYSICAL_COSTUMER: { color: '#f093fb', label: 'Cliente pessoa física' },
    ROLE_LEGAL_PERSON: { color: '#764ba2', label: 'Pessoa jurídica' },
    ROLE_EXTERNAL_EMPLOYEE: { color: '#f39c12', label: 'Colaborador externo' },
    ROLE_HR_EXTERNAL_EMPLOYEE: { color: '#30cfd0', label: 'RH colaborador externo' },
    ROLE_COST_CENTER_MANAGER: { color: '#11998e', label: 'Gestor de centro de custo' },
    ROLE_COST_CENTER_EMPLOYEE: { color: '#38ef7d', label: 'Colaborador de centro de custo' },
    ROLE_EXTERNAL_DELIVERY_CREATOR: { color: '#a855f7', label: 'Criador de entregas (cliente)' },
    ROLE_EMPLOYEE: { color: '#fa709a', label: 'Colaborador' },
    ROLE_HR_EMPLOYEE: { color: '#f64f59', label: 'RH' },
    ROLE_TRANSPORT_COMPANY: { color: '#3498db', label: 'Empresa de transporte' },
    ROLE_DRIVER: { color: '#e74c3c', label: 'Motorista' },
    ROLE_DELIVERY_CREATOR: { color: '#c471ed', label: 'Criador de entregas' },
    /** Legado — manter até a API deixar de enviar */
    ROLE_COMPANY: { color: '#4facfe', label: 'Companhia (legado)' },
    ROLE_COST_CENTER: { color: '#43e97b', label: 'Centro de custo (legado)' },
};

/** Roles que não podem ser removidas na edição */
export const PROTECTED_ROLES = ['ROLE_TRANSPORT_COMPANY', 'ROLE_PHYSICAL_COSTUMER', 'ROLE_LEGAL_PERSON'];

/** Roles definidas no cadastro / contexto da conta — não aparecem em “adicionar” */
export const NON_MANAGEABLE_ROLES = [
    'ROLE_TRANSPORT_COMPANY',
    'ROLE_PHYSICAL_COSTUMER',
    'ROLE_LEGAL_PERSON',
];

/** Só colaboradores da própria empresa de transporte (contexto “própria empresa”) */
export const TRANSPORT_COMPANY_ONLY_ROLES = [
    'ROLE_EMPLOYEE',
    'ROLE_HR_EMPLOYEE',
    'ROLE_DRIVER',
    'ROLE_DELIVERY_CREATOR',
];

/** Só colaboradores de clientes (contexto cliente selecionado) */
export const CLIENT_ONLY_ROLES = [
    'ROLE_EXTERNAL_EMPLOYEE',
    'ROLE_HR_EXTERNAL_EMPLOYEE',
    'ROLE_COST_CENTER_MANAGER',
    'ROLE_COST_CENTER_EMPLOYEE',
    'ROLE_EXTERNAL_DELIVERY_CREATOR',
];

/** Relatórios internos da transportadora (empresa de transporte e RH interno). */
export const TRANSPORT_COMPANY_REPORT_ROLES = [
    'ROLE_TRANSPORT_COMPANY',
    'ROLE_HR_EMPLOYEE',
];

/** Acesso à tela de rotas: somente empresa de transporte e RH interno. */
export const ROTAS_ACCESS_ROLES = [
    'ROLE_TRANSPORT_COMPANY',
    'ROLE_HR_EMPLOYEE',
];

/** Acesso à listagem e criação de entregas. */
export const ENTREGAS_ACCESS_ROLES = [
    'ROLE_DELIVERY_CREATOR',
    'ROLE_EXTERNAL_DELIVERY_CREATOR',
    'ROLE_TRANSPORT_COMPANY',
    'ROLE_HR_EXTERNAL_EMPLOYEE',
    'ROLE_LEGAL_PERSON',
    'ROLE_PHYSICAL_COSTUMER',
];

/** Relatórios por empresa (cliente): transportadora + o próprio cliente. */
export const COMPANY_REPORT_ROLES = [
    ...TRANSPORT_COMPANY_REPORT_ROLES,
    'ROLE_LEGAL_PERSON',
];

/** Acesso à tela de relatórios: união das roles dos relatórios do catálogo. */
export const REPORTS_ACCESS_ROLES = COMPANY_REPORT_ROLES;

/** Acesso à tela de configurações da transportadora. */
export const CONFIGURACOES_ACCESS_ROLES = [
    'ROLE_TRANSPORT_COMPANY',
];

/** Visão cliente das métricas operacionais (spec ampla). */
export const CLIENT_METRIC_ROLES = [
    'ROLE_LEGAL_PERSON',
    'ROLE_HR_EXTERNAL_EMPLOYEE',
    'ROLE_DELIVERY_CREATOR',
];

/** Maior autoridade primeiro (escolha da role “mais alta” do usuário logado) */
export const ROLE_HIERARCHY = [
    'ROLE_TRANSPORT_COMPANY',
    'ROLE_HR_EMPLOYEE',
    'ROLE_LEGAL_PERSON',
    'ROLE_HR_EXTERNAL_EMPLOYEE',
];
